import { Icon } from '@hologram-dimension/icon';
import { Modal } from '@hologram-dimension/modal';
import Pictogram from 'components/Pictogram/Pictogram';
import { useState, type FC } from 'react';
import { Feedback as FeedbackLink, NewSupportTicket, Support } from 'utils/constants/links';
import type { CommonModalProps } from '../shared';
import styles from './Feedback.module.css';

const Feedback: FC<CommonModalProps> = ({ onClose, defaultOpen = false, className }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Modal
      className={className}
      noContentPadding
      header="Help and feedback"
      onClosed={onClose}
      open={open}
      setOpen={setOpen}
    >
      {/* TODO: split this link markup into a separate component if needed */}
      <div className={styles.linkWrapper}>
        <a
          href={NewSupportTicket}
          target="_blank"
          rel="noreferrer"
          aria-label="Create a support ticket"
          className={styles.link}
        >
          <div className={styles.pictogram}>
            <Pictogram name="SubmitTicket" />
          </div>
          <div className={styles.linkText}>
            <p className={styles.linkTitle}>Create a support ticket</p>
            <p className={styles.linkDescription}>Need help? Get in touch with our support team</p>
          </div>
          <div className={styles.icon}>
            <Icon name="ArrowEastShort" />
          </div>
        </a>
      </div>
      <div className={styles.linkWrapper}>
        <a
          href={Support}
          target="_blank"
          rel="noreferrer"
          aria-label="Help center"
          className={styles.link}
        >
          <div className={styles.pictogram}>
            <Pictogram name="Help" />
          </div>
          <div className={styles.linkText}>
            <p className={styles.linkTitle}>Help center</p>
            <p className={styles.linkDescription}>Get advice and answers for deployments</p>
          </div>
          <div className={styles.icon}>
            <Icon name="ArrowEastShort" />
          </div>
        </a>
      </div>
      <div className={styles.linkWrapper}>
        <a
          href={FeedbackLink}
          target="_blank"
          rel="noreferrer"
          aria-label="Share feedback"
          className={styles.link}
        >
          <div className={styles.pictogram}>
            <Pictogram name="Feedback" />
          </div>
          <div className={styles.linkText}>
            <p className={styles.linkTitle}>Share feedback</p>
            <p className={styles.linkDescription}>Share your ideas and experiences with us</p>
          </div>
          <div className={styles.icon}>
            <Icon name="ArrowEastShort" />
          </div>
        </a>
      </div>
    </Modal>
  );
};

export default Feedback;
